var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.964,
    height: 68.147,
    viewBox: "0 0 79.964 68.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 79.964,
    height: 68.148,
    fill: "#ffbd00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10352",
    "data-name": "Group 10352",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10351",
    "data-name": "Group 10351",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27730",
    "data-name": "Path 27730",
    d: "M69.363,16.911H52.129V1.514A1.515,1.515,0,0,0,50.615,0H43.752L9.45,2.619A1.513,1.513,0,0,0,8.063,4.133v10.4a1.515,1.515,0,0,0,1.514,1.514h1.846v1.034a7.25,7.25,0,1,0,8.769,7.081,1.514,1.514,0,0,0-3.029,0,4.227,4.227,0,1,1-4.226-4.226,1.51,1.51,0,0,0,1.514-1.514V16.051h1.908a1.515,1.515,0,0,0,1.514-1.514V9.315H42.4V44.642H1.514A1.515,1.515,0,0,0,0,46.157V57.515a1.515,1.515,0,0,0,1.514,1.514H6.7a9.5,9.5,0,0,0,18.976,0H43.713a9.491,9.491,0,0,0,18.968,0H78.449a1.515,1.515,0,0,0,1.514-1.514V29.026c0-6.673-4.828-12.115-10.6-12.115m0,3.029c4.164,0,7.572,4.077,7.572,9.086v22.96H68.148A10.694,10.694,0,0,0,57.91,44.642h-5.5v-24.7ZM14.845,13.022H11.091V9.315h3.754ZM43.917,6.286H11.091V5.545L43.917,3.029H49.1V44.642H45.393V7.8a1.515,1.515,0,0,0-1.514-1.514ZM2.99,47.671H57.91a8.071,8.071,0,0,1,7.746,6.191v.151a.416.416,0,0,0,0,.141,1.107,1.107,0,0,0,.236.363.131.131,0,0,0,.079,0,1.039,1.039,0,0,0,.41.267,1.622,1.622,0,0,0,.577.127h9.63V55.9H62.052a9.48,9.48,0,0,0-18.039,0H25.147a9.48,9.48,0,0,0-18.023,0H2.99ZM16.131,65.4A6.463,6.463,0,1,1,22.6,58.95,6.465,6.465,0,0,1,16.131,65.4m37.07,0a6.463,6.463,0,1,1,6.467-6.451A6.454,6.454,0,0,1,53.2,65.4",
    fill: "#ffbd00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27731",
    "data-name": "Path 27731",
    d: "M49.941,30.271H54.1a1.514,1.514,0,1,0,0-3.029H49.941a1.514,1.514,0,0,0,0,3.029M10.219,43.206a4.374,4.374,0,1,0,3.116,1.286,4.406,4.406,0,0,0-3.116-1.286m0,5.767a1.371,1.371,0,0,1-1.286-.844,1.379,1.379,0,1,1,2.649-.521,1.359,1.359,0,0,1-1.363,1.365m37.07-5.767a4.407,4.407,0,1,0,4.394,4.4,4.4,4.4,0,0,0-4.394-4.4m0,5.767a1.38,1.38,0,1,1,1.365-1.365,1.361,1.361,0,0,1-1.365,1.365m4.725-24.3H66.133a1.515,1.515,0,0,0,1.514-1.514V19.095a7.982,7.982,0,0,0-7.966-7.966H52.015A1.514,1.514,0,0,0,50.5,12.643V23.157a1.515,1.515,0,0,0,1.514,1.514m1.514-10.514h6.152a4.953,4.953,0,0,1,4.937,4.937v2.548H53.529Z",
    transform: "translate(5.912 11.343)",
    fill: "#ffbd00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon5);
export default __webpack_public_path__ + "static/media/social_icon5.2686eea0282855e89a0d40b37a752f2a.svg";
export { ForwardRef as ReactComponent };